export default __webpack_public_path__ + "static/media/receipt.1709cfa6.svg";